// these constants are primarily used in user agent detection
export const UserAgentDetection = {
  BROWSER_CHECK_SESSION_FLAG: 'browserCheck',
  SUPPORTED_BROWSER: 'chrome',
  MIN_SUPPORTED_VERSION: '42',
};
